import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useUserData } from "store/slices/authSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  getStateDisclaimerRequestKey,
  selectStateDisclaimerEntry,
  stateDisclaimerGet,
  StateDisclaimerEntry,
  StateDisclaimerParams,
} from "store/slices/dashboardSlice";
import { decode } from "utils/HelperFunctions";

export const useStateDisclaimer = (enabled: boolean): StateDisclaimerEntry => {
  const dispatch = useAppDispatch();
  const userData = useUserData();
  const { id: actionId, clusterId: encodedClusterId } = useParams();
  const accountId = userData?.data?.accountData?.accountid;
  const accountClusterId = userData?.data?.accountData?.clusterid;

  const clusterId = useMemo(() => {
    if (actionId) {
      return String(decode(actionId)?.split("_")[1] || "");
    }

    if (accountClusterId) {
      return String(accountClusterId);
    }

    return String(decode(encodedClusterId || "", true) || "");
  }, [accountClusterId, actionId, encodedClusterId]);

  const params = useMemo<StateDisclaimerParams>(
    () => ({
      account_id: accountId,
      cluster_id: clusterId,
    }),
    [accountId, clusterId]
  );
  const requestKey = getStateDisclaimerRequestKey(params);
  const entry = useAppSelector((state) =>
    selectStateDisclaimerEntry(state, requestKey)
  );

  useEffect(() => {
    if (enabled && entry.status === "idle") {
      dispatch(stateDisclaimerGet(params));
    }
  }, [dispatch, enabled, entry.status, params]);

  return entry;
};
